import type { Edge, Node } from '@xyflow/react';
import type { OutputsResolver, WidgetNodeData } from '../../widgets/types';
import { pruneHandleActions } from './prune-handle-actions';
import { pruneOrphanedEdges } from './prune-orphaned-edges';

function pruneNodeActions(node: Node<WidgetNodeData>, outputsFor: OutputsResolver) {
  const pruned = pruneHandleActions(node.data.handleActions, outputsFor(node.type ?? '', node.data.config));
  if (pruned.changed === 0) return { node, changed: 0 };

  return { node: { ...node, data: { ...node.data, handleActions: pruned.handleActions } }, changed: pruned.changed };
}

export function pruneLoadedFlow(nodes: Node<WidgetNodeData>[], edges: Edge[], outputsFor: OutputsResolver) {
  const prunedNodes = nodes.map((n) => pruneNodeActions(n, outputsFor));
  const changedActions = prunedNodes.reduce((acc, n) => acc + n.changed, 0);
  const prunedEdges = pruneOrphanedEdges(nodes, edges, outputsFor);

  return {
    nodes: changedActions > 0 ? prunedNodes.map((n) => n.node) : nodes,
    edges: prunedEdges.edges,
    prunedCount: changedActions + prunedEdges.pruned.length,
  };
}
